import React from 'react'
import uniq from 'lodash.uniq'

import classNames from './AdvancedForm.css'
import ConfirmButtons from '../ConfirmButtons'
import GenericAutocomplete from '../GenericAutocomplete'
import LocationPicker from './LocationPicker'
import TimezonePicker from '../TimezonePicker'
import KeywordGraphPicker from '../KeywordGraphPicker'

export default function DynamicLinkForm ({ value, onChange, onCancel, addTerm, pristine, dynlinks }) {
  const input = (key, label) => (
    <label>
      {label}
      <input
        type='text'
        value={value[key] || ''}
        onChange={e => onChange({
          ...value,
          [key]: e.target.value
        })}
      />
    </label>
  )
  const onChangeType = e => onChange({
    ...value,
    type: e.target.value
  })
  const onSelectKeyword = node => {
    const index = value.keywordType && value.keywordType.findIndex(k => k.value === node.id)
    if (!value.keywordType || index === -1) {
      onChange({
        ...value,
        keywordType: (value.keywordType || []).concat({ value: node.id, operator: 'include' })
      })
    } else {
      if (value.keywordType[index].operator === 'include') {
        onChange({
          ...value,
          keywordType: [
            ...value.keywordType.slice(0, index),
            {
              ...value.keywordType[index],
              operator: 'exclude'
            },
            ...value.keywordType.slice(index + 1)
          ]
        })
      } else {
        onChange({
          ...value,
          keywordType: value.keywordType.filter(k => k.value !== node.id)
        })
      }
    }
  }
  const onChangeDateMargin = e => onChange({
    ...value,
    dateMargin: parseInt(e.target.value)
  })
  const toggleLocationOverride = () => onChange({
    ...value,
    locationOverride: !value.locationOverride || undefined
  })
  const onChangeLocation = location => onChange({ ...value, location })
  const conditions = value.type && dynlinks.filter(d => d.type === value.type).map(d => d.condition)
  const dateCondition = conditions && /^\d\d\d\d-\d\d-\d\d$/.test(conditions[0])
  const highlightKeywords = (dynlinks || []).filter(d => d.type === value.type).reduce(getDynlinkKeywords, [])
  return (
    <div className={classNames.form}>
      <label className={classNames.label}>
        Pick dynamic table to set condition
      </label>
      <select value={value.type || ''} onChange={onChangeType} style={{ width: 'auto' }}>
        <option value='' disabled>
          Select a table
        </option>
        {uniq((dynlinks || []).map(link => link.type)).map(value => <option key={value} value={value}>{value}</option>)}
      </select>
      {conditions &&
        <p className={classNames.note}>
          When one of the dynamic conditions are met, the keywords for that condition will be used for the image search.
        </p>
      }
      {conditions &&
        <p className={classNames.note}>
          The possible conditions are: <strong>{dateCondition ? 'dates' : conditions.join(', ')}</strong>
        </p>
      }
      {dateCondition &&
        <label>
          Plus or minus days (for date conditions)
          <input
            type='number'
            className={classNames.numberInput}
            value={value.dateMargin || ''}
            onChange={onChangeDateMargin}
          />
        </label>
      }
      {dateCondition &&
        <TimezonePicker
          value={value.time_offset}
          onChange={e => onChange({ ...value, time_offset: e.target.value })}
          label='Timezone (for date conditions)'
        />
      }
      <label className={classNames.label}>
        Filter by Keyword Type to match condition
      </label>
      <KeywordGraphPicker
        selected={(value.keywordType || []).filter(k => k.operator === 'include').map(k => k.value)}
        excluded={(value.keywordType || []).filter(k => k.operator === 'exclude').map(k => k.value)}
        onSelect={onSelectKeyword}
        highlightNodes={highlightKeywords}
        showSelectedChildrenIndicator
      />
      {!dateCondition && value.type &&
        <div>
          <label className={classNames.label}>
            Location override (for weather conditions)
          </label>
          <label>
            <input
              type='checkbox'
              checked={!value.locationOverride}
              onChange={toggleLocationOverride}
            />
            Use default device location
          </label>
          {value.locationOverride &&
            <LocationPicker
              value={value.location}
              onChange={onChangeLocation}
              disabled={!value.locationOverride}
            />
          }
        </div>
      }
      <ConfirmButtons
        onCancel={() => {
          onCancel()
          onChange({})
        }}
        confirmText='Submit'
        onConfirm={() => {
          addTerm('dynlink', value)
          onChange({})
        }}
        confirmDisabled={pristine}
      />
    </div>
  )
}

function getDynlinkKeywords (array, dynlink) {
  return array.concat(JSON.parse(dynlink.keywords))
}



// WEBPACK FOOTER //
// ./src/components/search/DynamicLinkForm.js